<template>
  <div class="medal-manage">
    <el-card class="medal-manage__card">
      <div class="medal-manage__title">
        勋章管理
      </div>
      <div class="process-box">
        勋章类型:
        <el-select v-model="searchData.medalType" placeholder="Total" style="margin-right: 10px;">
          <el-option :label="medalTypeConst[key]" :value="key" v-for="(item, key) in medalTypeConst"
            :key="item"></el-option>
        </el-select>
        勋章种类:
        <el-select v-model="searchData.medalCategory" placeholder="Total" style="margin-right: 10px;">
          <el-option :label="item.label" :value="item.value" v-for="(item, key) in medalCategoryConst"
            :key="item.value"></el-option>
        </el-select>
        是否有效:
        <el-select v-model="searchData.valid" placeholder="Total" style="margin-right: 10px;">
          <el-option label="Total" :value="null"></el-option>
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="2"></el-option>
        </el-select>
        渠道:
        <el-select v-model="searchData.channel" placeholder="Total" style="margin-right: 10px;" filterable clearable>
          <el-option v-for="item in channelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        勋章名称：
        <el-input v-model="searchData.medalName" placeholder="请输入内容" style="width: 180px; margin-right: 10px;"></el-input>
        <el-button type="primary" @click="paramSearchHandle">查询</el-button>
        <el-button icon="el-icon-plus" type="success" @click="addMedalBtnHandle">新增</el-button>
      </div>
      <el-table height="65vh" :data="medalData" v-loading="loading">
        <el-table-column prop="medalId" label="勋章id" align="center">
        </el-table-column>
        <!-- 勋章类型 1-签到 2-玩游戏 3-分享 4-充值 5-直播 -->
        <el-table-column prop="stickerText" label="勋章种类" align="center">
          <template slot-scope="scope">
            {{ medalAllCategoryConst[scope.row.medalCategory].label }}
          </template>
        </el-table-column>
        <!-- 所有勋章0，成就勋章1，活动勋章2，赠送勋章3 -->
        <el-table-column prop="stickerText" label="勋章类型" align="center">
          <template slot-scope="scope">
            {{ medalTypeConst[scope.row.medalType] }}
          </template>
        </el-table-column>
        <el-table-column prop="medalName" label="名称"></el-table-column>
        <el-table-column prop="channel" label="渠道"></el-table-column>
        <el-table-column prop="test" label="未点亮图片">
          <template slot-scope="scope">
            <img class="medal-img" :src="getBlackImg(scope.row.medalIconPath)" alt="未点亮图片">
          </template>
        </el-table-column>
        <el-table-column label="点亮图片" prop="medalIconPath">
          <template slot-scope="scope">
            <img class="medal-img" :src="scope.row.medalIconPath" alt="点亮图片">
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="medalDesc">
          <template slot-scope="scope">
            {{ scope.row.medalDesc.replace('$needProcess', scope.row.needProcess) }}
          </template>
        </el-table-column>
        <el-table-column label="进度值" prop="needProcess"></el-table-column>
        <el-table-column label="有效期时间" prop="effectiveDay">
          <template slot-scope="scope">
            <div>
              {{ scope.row.effectiveDay === -1 ? '永久' : scope.row.effectiveDay + '天' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sortId"></el-table-column>
        <el-table-column label="是否有效" prop="scope">
          <template slot-scope="scope">
            {{ scope.row.valid === 1 ? '有效' : '无效' }}
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operator"></el-table-column>
        <el-table-column label="操作时间" width="150px">
          <template slot-scope="scope">
            {{ formatDay(scope.row.mtime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作按钮" width="200px">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="editRowHandle(scope.row)">更新</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.valid !== 1"
              @click="listMedal(0, scope.row)">上架</el-button>
            <el-button size="mini" type="danger" v-else @click="listMedal(1, scope.row)">下架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="currentPage"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-card>
    <el-dialog :title="isAddMedal ? '新增勋章' : '编辑勋章'" :visible.sync="dialogVisible" width="50%"
      :before-close="handleDialogClose">
      <div class="item">
        <el-alert type="info" description="上传图片文件名对应，灰度xxx_dark.png/webp...,点亮图应为xxx.png/webp" :closable="false">
        </el-alert>
      </div>
      <div class="item">
        <span>渠道: </span>
        <el-select v-model="submitForm.channel" placeholder="选择渠道" :disabled="!isAddMedal" filterable clearable>
          <el-option v-for="item in channelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>勋章Id: </span>
        <el-input type="text" v-model="submitForm.medalId" style="width: 215px;" :disabled="!isAddMedal"></el-input>
      </div>
      <div class="item">
        <span>勋章类型: </span>
        <el-select v-model="submitForm.medalType" style="margin-right: 10px;">
          <el-option :label="medalTypeConst[key + 1]" :value="key + 1" v-for="(item, key) in 3" :key="item"></el-option>
        </el-select>
      </div>
      <div class="item" v-show="submitForm.medalType < 2">
        <span>勋章种类: </span>
        <el-select v-model="submitForm.medalCategory" style="margin-right: 10px;">
          <el-option :label="medalAllCategoryConst[item].label" :value="medalAllCategoryConst[item].value"
            v-for="(item, key) in submitForm.channel == 'cdd' ? cddList : cdeList" :key="item"></el-option>
        </el-select>
        <span>勋章进度值: </span>
        <el-input type="text" v-model="submitForm.needProcess" style="width: 215px;"></el-input>
      </div>
      <div class="item">
        <span>勋章名称:</span>
        <el-input type="text" v-model="submitForm.medalName" style="width: 215px;"></el-input>
      </div>
      <div class="item">
        <span>勋章描述</span>
        <el-input type="textarea" v-model="submitForm.medalDesc" style="width: 215px;"></el-input>
      </div>
      <div class="item">
        <span>勋章未点亮图</span>
        <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
          :on-change="value => changFile(1, value)" ref="upload">
          <el-image v-if="submitForm.blackImg !== ''" style="width: 215px; height: auto" :src="submitForm.blackImg"
            fit="scale-down"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>勋章点亮图:</span>
        <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
          :on-change="value => changFile(2, value)" ref="upload">
          <el-image v-if="submitForm.medalIconPath !== ''" style="width: 215px; height: auto"
            :src="baseUrl + submitForm.medalIconPath" fit="scale-down"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>勋章有效期:</span>
        <el-radio-group v-model="submitForm.isEffective">
          <el-radio :label="-1">永久</el-radio>
          <el-radio :label="1">有效期</el-radio>
        </el-radio-group>
        <el-input type="text" v-if="submitForm.isEffective !== -1" v-model="submitForm.effectiveDay"
          style="width: 50px; margin: 0 20px;"></el-input> Day
      </div>
      <div class="item">
        <span>勋章排序:</span>
        <el-input type="text" v-model="submitForm.sortId" style="width: 215px;"></el-input>
      </div>
      <div class="item">
        <span>是否有效:</span>
        <el-switch v-model="submitForm.valid" active-text="有效" inactive-text="无效" :active-value="1"
          :inactive-value="0"></el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button @click="uploadReqBtnHandle(0)" type="primary" v-if="isAddMedal">
          新 增
        </el-button>
        <el-button v-loading="uploadProcess" @click="uploadReqBtnHandle(1)" type="primary" v-else>
          编 辑
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMedalList, insertMedal, updateMedal } from '@/api/medalRequest'
import { newChannelList } from '@/utils/normalApi'
import dayjs from "dayjs"
export default {
  data() {
    return {
      baseUrl: '',
      channelList: [],
      // 查找数据
      searchData: {
        medalType: 0,
        medalCategory: 0,
        valid: null,
        medalName: '',
        channel: ''
      },
      // 列表数据
      medalData: [],
      total: 0,
      currentPage: 1,
      // 加载中
      loading: false,
      // 上传图片中
      uploadProcess: false,
      // 常量数据
      medalCategoryConst: [{ label: 'Total', value: 0 }, { label: '签到', value: 1 }, { label: '玩游戏', value: 2 },
      { label: '分享', value: 3 }, { label: '充值', value: 4 }, { label: '直播', value: 5 }, { label: '注册天数', value: 6 },
      { label: '周年庆天数', value: 7 }, { label: 'PARTY天数', value: 8 }, { label: '未定义勋章', value: 9 }, { label: '分享PARTY总次数', value: 10 },
      { label: 'vip会员勋章', value: 11 }
      ],
      medalAllCategoryConst: [{ label: 'Total', value: 0 }, { label: '签到', value: 1 }, { label: '玩游戏', value: 2 },
      { label: '分享', value: 3 }, { label: '充值', value: 4 }, { label: '直播', value: 5 }, { label: '注册天数', value: 6 },
      { label: '周年庆天数', value: 7 }, { label: 'PARTY天数', value: 8 }, { label: '未定义勋章', value: 9 }, { label: '分享PARTY总次数', value: 10 },
      { label: 'vip会员勋章', value: 11 }
      ],
      cddList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      cdeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      medalTypeConst: ['Total', '成就勋章', '活动勋章', '赠送勋章'],
      // 弹窗数据
      dialogVisible: false,
      isAddMedal: true,
      // 提交弹窗
      submitForm: {
        medalId: '',
        medalType: 1,
        medalCategory: 1,
        needProcess: 0,
        sortId: 0,
        medalDesc: '',
        medalName: '',
        medalIconPath: '',
        valid: 1,
        isEffective: -1,
        effectiveDay: 0,
        blackImg: '',
        channel: ''
      }

    }
  },
  async mounted() {
    await this.fetchChannelList()
  },
  watch: {
    'searchData.channel': {
      handler(newVal) {
        const cddList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        const cdeList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        const constVal = [{ label: 'Total', value: 0 }, { label: '签到', value: 1 }, { label: '玩游戏', value: 2 },
        { label: '分享', value: 3 }, { label: '充值', value: 4 }, { label: '直播', value: 5 }, { label: '注册天数', value: 6 },
        { label: '周年庆天数', value: 7 }, { label: 'PARTY天数', value: 8 }, { label: '未定义勋章', value: 9 }, { label: '分享PARTY总次数', value: 10 },
        { label: 'vip会员勋章', value: 11 }
        ]
        let curChannelList = newVal === 'cdd' ? cddList : cdeList
        this.searchData.medalCategory = 0
        this.medalCategoryConst = curChannelList.map(index => constVal[index])
      },
      immediate: true
    }
  },
  methods: {
    async fetchChannelList() {
      const res = await newChannelList()
      this.channelList = Array.isArray(res) ? res : []
      if (!this.searchData.channel && this.channelList.length) {
        this.searchData.channel = this.channelList[0].value
      }
      if (!this.submitForm.channel && this.channelList.length) {
        this.submitForm.channel = this.channelList[0].value
      }
    },

    // 展示提示消息
    showMsg(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: res.msg
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.msg
        })
      }
    },

    // 请求勋章列表
    async medalListReq(page, data) {
      this.currentPage = page
      this.loading = true
      const res = await getMedalList(page, data)
      this.medalData = res.data.data
      this.total = res.data.total
      this.loading = false
      this.showMsg(res)
    },

    // 通过参数查询列表
    paramSearchHandle() {
      this.currentPage = 1

      this.medalListReq(1, this.searchData)
    },

    // 触发分页
    handleCurrentChange(page) {
      this.medalListReq(page, this.searchData)
    },

    // 添加，编辑弹窗对应处理
    addMedalBtnHandle() {
      this.dialogVisible = true
      this.isAddMedal = true
      if (this.channelList.length) {
        this.submitForm.channel = this.channelList[0].value
      }
    },

    // 编辑行处理
    editRowHandle(row) {
      this.dialogVisible = true
      this.isAddMedal = false
      this.submitForm = JSON.parse(JSON.stringify(row))
      this.$set(this.submitForm, 'isEffective', (row.effectiveDay === -1) ? -1 : 1)
      this.$set(this.submitForm, 'blackImg', this.getBlackImg(this.submitForm.medalIconPath))
    },

    // 弹窗关闭事件
    handleDialogClose() {
      this.submitForm = {
        medalId: '',
        medalType: 1,
        medalCategory: 1,
        needProcess: 0,
        sortId: 0,
        medalDesc: '',
        medalName: '',
        medalIconPath: '',
        valid: 1,
        isEffective: -1,
        effectiveDay: 0,
        blackImg: '',
        channel: 'cdd'
      }
      this.dialogVisible = false
    },

    // 图片上传
    async changFile(type, file) {
      this.uploadProcess = true
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('cover', 1)
      formData.append('dir', 'icon/meadl/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      this.uploadProcess = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type == 2) {
        this.submitForm.medalIconPath = res.data
      } else if (type == 1) {
        this.submitForm.blackImg = res.data
      }
    },

    // 上下架操作
    listMedal(code, row) {
      this.$confirm('是否执行该操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateMedal(code, row.id)
        this.showMsg(res)
        this.paramSearchHandle()
      })
    },

    // 时间格式化
    formatDay(timestamp) {
      if (timestamp === 0) {
        return '无'
      }
      return dayjs(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss")
    },

    // 新增，编辑行处理 (0新增，1编辑)
    async uploadReqBtnHandle(num) {
      let res = null
      if (num === 0) {
        const insertObj = JSON.parse(JSON.stringify(this.submitForm))
        if (insertObj.isEffective === -1) {
          insertObj.effectiveDay = -1
        }
        delete insertObj.blackImg
        delete insertObj.isEffective
        delete insertObj.id
        insertObj.needProcess = Number(insertObj.needProcess)
        insertObj.sortId = Number(insertObj.sortId)
        // 勋章类型判断
        if (insertObj.medalType > 1) {
          insertObj.needProcess = 0
          insertObj.medalCategory = 0
        }

        res = await insertMedal(insertObj)
      } else {
        const updateObj = JSON.parse(JSON.stringify(this.submitForm))
        if (updateObj.isEffective === -1) {
          updateObj.effectiveDay = -1
        }
        delete updateObj.blackImg
        delete updateObj.isEffective
        // 勋章类型判断
        if (updateObj.medalType > 1) {
          updateObj.needProcess = 0
          updateObj.medalCategory = 0
        }

        res = await updateMedal(null, updateObj)
      }
      this.handleDialogClose()
      this.paramSearchHandle()
      this.showMsg(res)
    },

    isImage(fileName) {
      var pattern = /\.(jpg|jpeg|png|gif|webp)$/i;
      return pattern.test(fileName);
    },

    // 获取勋章未点亮图
    getBlackImg(url) {
      if (this.isImage(url)) {
        var lastIndex = url.lastIndexOf(".");
        var newName = url.slice(0, lastIndex) + "_dark" + url.slice(lastIndex);
        return newName;
      } else {
        return url;
      }
    },

    refreshImg(ref) {
      const src = ref.src
      const curTime = Number(new Date());
      ref.src = src + '?t='
    }
  }
}
</script>

<style scoped lang ="scss">
.el-select {
  width: 150px;
}

.medal-manage {
  &__card {
    margin: 0 20px;
    padding: 20px 10px;
  }

  &__title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 26px;
  }
}

.medal-img {
  width: 50px;
}

.item {
  display: flex;
  margin: 10px 0;
  align-items: center;

  span {
    width: 100px;
  }
}
</style>